import React from "react";
import { Card, CardContent, Typography, Grid2 as Grid } from "@mui/material";

interface ViewFieldCardProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Card component for grouping related fields in view mode.
 * Provides visual organization with a section title.
 */
const ViewFieldCard: React.FC<ViewFieldCardProps> = ({ title, children }) => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            color: "primary.main",
            fontWeight: "bold",
          }}
        >
          {title}
        </Typography>
        <Grid container spacing={2}>
          {children}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ViewFieldCard;

